import React from "react";
import Sidebar from "../Sidebar";
import Header from "../Header/Header";
import { createContext, useState } from "react";

export const LayoutContext = createContext();

const Layout = ({ children }) => {
  const [openSidebar, setOpenSidebar] = useState(false);
  return (
    <LayoutContext.Provider value={{ openSidebar, setOpenSidebar }}>
      <div className="w-full h-full flex gap-4">
        <Sidebar />
        <div className="flex flex-col gap-4 p-4 bg-[#c8d9d663] flex-grow">
          <Header selectedMenu={(selectedOption) => selectedOption} />
          {children}
        </div>
      </div>
    </LayoutContext.Provider>
  );
};

export default Layout;
